// extracted by mini-css-extract-plugin
export default {"root":"StepStart_root__N7D49"};